import React, { useEffect, useRef, useState } from "react";
import { Styles } from "./styles";
import userImg from "../../../Assets/images/icons/user.png";
import { useParams } from "react-router-dom";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { errorToaster } from "../../../helper/toasterConfiguration";
import { CircularProgress } from "@mui/material";
import pusher from "../../../helper/pusher.js";
import { useNotifications } from "../../../Context/notificationContext.js";
const ChatComponent = ({ data, getData, isSendLoading, setIsSendLoading }) => {
  const { id } = useParams();
  const { dispatch } = useNotifications();
  const [message, setMessage] = useState("");
  const [incomingmessages, setIncomingMessages] = useState([]);
  const messagesRef = useRef(null);
  const scrollToBottom = () => {
    if (messagesRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }
  };
  useEffect(() => {
    const channel = pusher.subscribe(`SupportChat${id}`);
    const handleNewMessage = (newMessage) => {
      if (newMessage.role === "user") dispatch({ type: "ADD_NOTIFICATION" });
      setIncomingMessages((prev) => {
        if (
          !prev.some((msg) => msg.id === newMessage.id) &&
          !data.some((msg) => msg.id === newMessage.id)
        ) {
          return [...prev, newMessage];
        }
        return prev;
      });
    };
    channel.bind("chatSupport-event", handleNewMessage);
    return () => {
      pusher.unsubscribe("SupportChat");
    };
  }, [data]);
  useEffect(() => {
    setIncomingMessages((prev) =>
      prev.filter(
        (incomingMsg) => !data.some((dataMsg) => dataMsg.id === incomingMsg.id)
      )
    );
    scrollToBottom();
  }, [data]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    setIsSendLoading(true);
    const { response, message: ApiMessage } = await Helper.Post({
      url: api_Routes.Support.Replay,
      data: {
        message,
        ticket_support_id: id,
      },
      hasToken: true,
    });
    if (response) {
      getData(); // Fetch latest messages from the database
    } else {
      console.log(ApiMessage);
      setIsSendLoading(false);
      errorToaster(ApiMessage);
    }
    if (message.trim()) {
      setMessage("");
    }
  };

  return (
    <Styles>
      <div className="chat">
        <div className="messages" ref={messagesRef}>
          {/* Incoming message */}
          {data?.map((item, idx) => {
            if (item?.admin_id) {
              return (
                <div className="message-container incoming-message" key={idx}>
                  <div className="data">
                    <div className="user">
                      <img
                        src={
                          JSON.parse(localStorage.getItem("user"))?.photo_url ||
                          userImg
                        }
                        alt={JSON.parse(localStorage.getItem("user"))?.name}
                      />
                    </div>
                    <div className="message">{item?.message}</div>
                  </div>
                  <div className="date">{item?.crated_at}</div>
                </div>
              );
            } else {
              return (
                <div
                  className="message-container outcoming-message"
                  key={item?.id}
                >
                  <div className="data">
                    <div className="user">
                      <img src={item?.photo || userImg} alt={item?.name} />
                    </div>
                    <div className="message">{item?.message}</div>
                  </div>
                  <div className="date">{item?.crated_at}</div>
                </div>
              );
            }
          })}
          {incomingmessages &&
            incomingmessages.map((item) => {
              if (item?.role === "user") {
                return (
                  <div
                    className="message-container outcoming-message"
                    key={item?.id}
                  >
                    <div className="data">
                      <div className="user">
                        <img src={item?.photo || userImg} alt={item?.name} />
                      </div>
                      <div className="message">{item?.message}</div>
                    </div>
                    <div className="date">{item?.created_at}</div>
                  </div>
                );
              }
            })}
        </div>
        <div className="footer">
          <form onSubmit={handleSendMessage}>
            <textarea
              name="message"
              placeholder="Type a message"
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <button
              type="submit"
              className="send"
              aria-label="Send message"
              disabled={isSendLoading || message?.length === 0}
            >
              {isSendLoading ? (
                <CircularProgress size={22} sx={{ color: "white" }} />
              ) : (
                "Send"
              )}
            </button>
          </form>
        </div>
      </div>
    </Styles>
  );
};

export default ChatComponent;
